module.exports = __webpack_public_path__ + "static/stripe_secure_small.eedbb42e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stripe_secure_small.jpg
// module id = 643
// module chunks = 11557164830295